import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetBingoJackpots = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (options: Types.IBingoJackpotsRequestData): Promise<Types.IBingoJackpotsResponseData> => {
        const { data } = await send<Types.IBingoJackpotsRequestData, Types.IBingoJackpotsResponseData>({
            ID: 81704,
            description: 'Get Bingo Jackpots',
            responses: [81705, 81706],
            version: '1.7',
            uniqueJackpots: true,
            casino: casinoName,
            ...options
        });

        return data;
    }, [send, casinoName]);
};
